import Axios from '../axios.js'
/**********************************************************************************
 * 班组管理
 **********************************************************************************/
export default {
	exportProcessEnergy: (dayType,startTime,endTime,processList,deviceList,success,failure) => {
		Axios.post('/teamAssessment/exportProcessEnergy.do', {
			dayType,
			startTime,
			endTime,
			processList,
			deviceList
		},success,failure)
	},
	getProcessDevice: (appTyPeNo,success,failure) => {
			Axios.post('/virtualDevice/getProcessDevice.do', {
				appTyPeNo
			},success,failure)
	},
	getProcessRanking:(dayType,startTime,endTime,success,failure) => {
		Axios.post('/teamAssessment/getProcessRanking.do', {
			dayType,
			startTime,
			endTime
		},success,failure)
	},
	/**
	 * 查询勾选工艺的能耗
	 * @param dayType
	 * @param startTime
	 * @param endTime
	 * @param processList
	 * @param deviceList
	 * @param success
	 * @param failure
	 */
	getCheckedProcessEnergy:(dayType,startTime,endTime,processList,deviceList,appTypeNos,success,failure) => {
		Axios.post('/teamAssessment/getCheckedProcessEnergy.do', {
			dayType,
			startTime,
			endTime,
			processList,
			deviceList,
			appTypeNos
		},success,failure)
	},
	/**
	 * 虚拟设备组班组树
	 */
	getDeviceAndTeamTree: (success, failure) => {
		Axios.post('/teamAssessment/getDeviceAndTeamTree.do', {}, success, failure);
	},
	/**********************************************************************************
	 * 工作时间模板
	 **********************************************************************************/
	/**
	 * 时间模板树
	 */
	getAllTimeTemplate: (success, failure) => {
		Axios.post('/teamAssessment/getAllTimeTemplate.do', {
		}, success, failure);
	},
	/**
	 * 时间模板树
	 */
	addTimeTemplate: (templateName, workTime, success, failure) => {
		Axios.post('/teamAssessment/saveTimeTemplate.do', {
			templateName,
			workTime
		}, success, failure);
	},
	/**
	 * 时间模板树
	 */
	updateTimeTemplate: (pkid, templateName, workTime, success, failure) => {
		Axios.post('/teamAssessment/saveTimeTemplate.do', {
			pkid,
			templateName,
			workTime
		}, success, failure);
	},
	deleteTimeTemplate:(pkid,success, failure)=> {
		Axios.post('/teamAssessment/deleteTimeTemplate.do', {
			pkid
		}, success, failure);
	},
	/**********************************************************************************
	 * 虚拟设备组
	 **********************************************************************************/
	/**
	 * 虚拟设备组树
	 */
	getDeviceGroupTree: (unitId,success, failure) => {
		Axios.post('/teamAssessment/getDeviceGroupTree.do', {unitId}, success, failure);
	},
	/**
	 * 添加虚拟设备组
	 * @param {jsonArray} deviceJson [{"deviceNo":12,"deviceName":"hhhhh"},{"deviceNo":13,"deviceName":"kkkk"}]
	 */
	addVirtualDeviceGroup: (groupName, parentId, deviceJson, success, failure) => {
		Axios.post('/teamAssessment/saveVirtualDeviceGroup.do', {
			groupName,
			parentId,
			deviceJson
		}, success, failure);
	},
	/**
	 * 修改虚拟设备组
	 * @param {jsonArray} deviceJson [{"deviceNo":12,"deviceName":"hhhhh"},{"deviceNo":13,"deviceName":"kkkk"}]
	 */
	updateVirtualDeviceGroup: (groupId, groupName, deviceJson, success, failure) => {
		Axios.post('/teamAssessment/saveVirtualDeviceGroup.do', {
			groupId,
			groupName,
			deviceJson
		}, success, failure);
	},
	/**
	 * 删除虚拟设备组
	 */
	deleteVirtualDeviceGroup: (groupId, success, failure) => {
		Axios.post('/teamAssessment/deleteVirtualDeviceGroup.do', {
			groupId
		}, success, failure);
	},
	/**********************************************************************************
	 * 班组
	 **********************************************************************************/
	/**
	 * 班组列表
	 */
	getTeamGroupList: (success, failure) => {
		Axios.post('/teamAssessment/getTeamGroupList.do', {}, success, failure);
	},
	/**
	 * 添加班组
	 * @param {JSONArray} deviceGroupJson json数组格式：[{"deviceGroupId":"虚拟设备组id","workTime":"00:00,00:30,01:00,01:30","remarks":"备注"}]
	 */
	addTeamGroup: (groupName, deviceGroupJson, success, failure) => {
		Axios.post('/teamAssessment/saveTeamGroup.do', {
			groupName,
			deviceGroupJson
		}, success, failure);
	},
	/**
	 * 修改班组
	 */
	updateTeamGroup: (groupId, groupName, deviceGroupJson, success, failure) => {
		Axios.post('/teamAssessment/saveTeamGroup.do', {
			groupId,
			groupName,
			deviceGroupJson
		}, success, failure);
	},
	/**
	 * 删除班组
	 */
	deleteTeamGroup: (groupId, success, failure) => {
		Axios.post('/teamAssessment/deleteTeamGroup.do', {
			groupId
		}, success, failure);
	},
	/**
	 * 统计班组考核期用电量
	 */
	countTeamGroupElectricity: (time, pageIndex, pageSize, success, failure) => {
		Axios.post('/teamAssessment/countTeamGroupElectricity.do', {
			time, pageIndex, pageSize
		}, success, failure);
	},
	getTeamGroupEelecRanking:(type,startTime,endTime,success,failure) => {
		Axios.post('/teamAssessment/getTeamGroupEelecRanking.do',{
			type,startTime,endTime
		},success,failure)
	},
	/**
	 * 导出班组考核
	 */
	exportTeamGroupElectricity: (beginTime,endTime,success, failure) => {
		Axios.post('/teamAssessment/exportTeamGroupElectricity.do', {
			beginTime,endTime
		}, success, failure);
	},
	/**
	 * 导出班组考核
	 */
	exportTeamGroupElectricity1: (type,time,success, failure) => {
		Axios.post('/teamAssessment/exportTeamGroupElectricity1.do', {
			type,
			time
		}, success, failure);
	},
}